export const PREMISSIONS = {
    "FinancialYear": {
        "View": "Permissions.FinancialYear.View",
        "Search": "Permissions.FinancialYear.Search",
        "Create": "Permissions.FinancialYear.Create",
        "Update": "Permissions.FinancialYear.Update",
        "Delete": "Permissions.FinancialYear.Delete",
        "Generate": "Permissions.FinancialYear.Generate"
    },
    "Dashboard": {
        "View": "Permissions.Dashboard.View",
        "Export": "Permissions.Dashboard.Export"
    },
    "ManualInventory": {
        "View": "Permissions.ManualInventory.View",
        "Search": "Permissions.ManualInventory.Search",
        "Create": "Permissions.ManualInventory.Create",
        "Update": "Permissions.ManualInventory.Update",
        "Delete": "Permissions.ManualInventory.Delete",
        "Export": "Permissions.ManualInventory.Export"
    },
    "Hangfire": {
        "View": "Permissions.Hangfire.View"
    },
    "Setting": {
        "UpSert": "Permissions.Setting.UpSert",
        "View": "Permissions.Setting.View",
        "Search": "Permissions.Setting.Search"
    },
    "Users": {
        "View": "Permissions.Users.View",
        "Search": "Permissions.Users.Search",
        "Create": "Permissions.Users.Create",
        "Update": "Permissions.Users.Update",
        "Delete": "Permissions.Users.Delete"
    },
    "ZatcaUnits": {
        "View": "Permissions.ZatcaUnit.View",
        "Search": "Permissions.ZatcaUnit.Search",
        "Create": "Permissions.ZatcaUnit.Create",
        "Update": "Permissions.ZatcaUnit.Update",
        "Delete": "Permissions.ZatcaUnit.Delete"
    },
    "Vendor": {
        "View": "Permissions.Vendor.View",
        "Search": "Permissions.Vendor.Search",
        "Create": "Permissions.Vendor.Create",
        "Update": "Permissions.Vendor.Update",
        "Delete": "Permissions.Vendor.Delete"
    },
    "Customer": {
        "View": "Permissions.Customer.View",
        "Search": "Permissions.Customer.Search",
        "Create": "Permissions.Customer.Create",
        "Update": "Permissions.Customer.Update",
        "Delete": "Permissions.Customer.Delete"
    },
    "GeneralSettings": {
        "View": "Permissions.GeneralSettings.View",
        "UpSert": "Permissions.GeneralSettings.UpSert"
    },
    "JournalTypes": {
        "View": "Permissions.JournalTypes.View",
        "Search": "Permissions.JournalTypes.Search",
        "Create": "Permissions.JournalTypes.Create",
        "Update": "Permissions.JournalTypes.Update",
        "Delete": "Permissions.JournalTypes.Delete"
    },
    "Journal": {
        "View": "Permissions.Journal.View",
        "Search": "Permissions.Journal.Search",
        "Create": "Permissions.Journal.Create",
        "Update": "Permissions.Journal.Update",
        "Delete": "Permissions.Journal.Delete"
    },
    "ReceiptVoucher": {
        "View": "permissions.receiptvoucher.view",
        "Search": "permissions.receiptvoucher.search",
        "Create": "permissions.receiptvoucher.create",
        "Update": "permissions.receiptvoucher.update",
        "Approve": "permissions.receiptvoucher.approve",
        "Delete": "permissions.receiptvoucher.delete",
        "Export": "permissions.receiptvoucher.export"
    },
    "PaymentVoucher": {
        "View": "permissions.paymentvoucher.view",
        "Search": "permissions.paymentvoucher.search",
        "Create": "permissions.paymentvoucher.create",
        "Update": "permissions.paymentvoucher.update",
        "Approve": "permissions.paymentvoucher.approve",
        "Delete": "permissions.paymentvoucher.delete",
        "Export": "permissions.paymentvoucher.export"
    },
    "Invoice": {
        "Generate": "Permissions.Invoice.Generate"
    },

    "OpeningBalance": {
        "View": "Permissions.OpeningBalance.View",
        "Search": "Permissions.OpeningBalance.Search",
        "UpSert": "permissions.openingbalance.create",
        "Delete": "Permissions.OpeningBalance.Delete",
        "Init": "Permissions.OpeningBalance.Init"
    },
    "IntermediateAccount": {
        "View": "Permissions.IntermediateAccount.View",
        "Search": "Permissions.IntermediateAccount.Search",
        "UpSert": "Permissions.IntermediateAccount.create",
        "Delete": "Permissions.IntermediateAccount.Delete",
        "Init": "Permissions.IntermediateAccount.Init"
    },
    "OpeningStock": {
        "View": "Permissions.OpeningStock.View",
        "Create": "Permissions.OpeningStock.Create",
        "Update": "Permissions.OpeningStock.Update",
        "Delete": "Permissions.OpeningStock.Delete"
    },
    "Contact": {
        "View": "Permissions.Contact.View",
        "Search": "Permissions.Contact.Search",
        "Create": "Permissions.Contact.Create",
        "Update": "Permissions.Contact.Update",
        "Delete": "Permissions.Contact.Delete"
    },
    "Employee": {
        "View": "Permissions.Employee.View",
        "Search": "Permissions.Employee.Search",
        "Create": "Permissions.Employee.Create",
        "Update": "Permissions.Employee.Update",
        "Delete": "Permissions.Employee.Delete"
    },
    "Company": {
        "View": "Permissions.Company.View",
        "Search": "Permissions.Company.Search",
        "Create": "Permissions.Company.Create",
        "Update": "Permissions.Company.Update",
        "Delete": "Permissions.Company.Delete"
    },
    "Branch": {
        "View": "Permissions.Branch.View",
        "Search": "Permissions.Branch.Search",
        "Create": "Permissions.Branch.Create",
        "Update": "Permissions.Branch.Update",
        "Delete": "Permissions.Branch.Delete"
    },
    "Store": {
        "View": "Permissions.Store.View",
        "Search": "Permissions.Store.Search",
        "Create": "Permissions.Store.Create",
        "Update": "Permissions.Store.Update",
        "Delete": "Permissions.Store.Delete"
    },
    "Unit": {
        "View": "Permissions.Unit.View",
        "Search": "Permissions.Unit.Search",
        "Export": "Permissions.Unit.Export",
        "Create": "Permissions.Unit.Create",
        "Update": "Permissions.Unit.Update",
        "Delete": "Permissions.Unit.Delete"
    },
    "Reports": {
        "View": "Permissions.Reports.View",
        "Search": "Permissions.Reports.Search",
        "Export": "Permissions.Reports.Export"
    },
    "Roles": {
        "View": "Permissions.Roles.View",
        "Update": "Permissions.Roles.Update",
        "Create": "Permissions.Roles.Create",
        "Delete": "Permissions.Roles.Delete"
    },
    "UserRoles": {
        "View": "Permissions.UserRoles.View",
        "Search": "Permissions.UserRoles.Search",
        "Update": "Permissions.UserRoles.Update",
        "Create": "Permissions.UserRoles.Create",
        "Delete": "Permissions.UserRoles.Delete",
        "DDL": "Permissions.UserRoles.DDL"
    },
    "RoleClaims": {
        "View": "Permissions.RoleClaims.View",
        "Search": "Permissions.RoleClaims.Search",
        "Update": "Permissions.RoleClaims.Update",
        "Create": "Permissions.RoleClaims.Create",
        "Delete": "Permissions.RoleClaims.Delete"
    },
    "UserClaims": {
        "View": "Permissions.UserClaims.View",
        "Search": "Permissions.UserClaims.Search",
        "Update": "Permissions.UserClaims.Update",
        "Create": "Permissions.UserClaims.Create",
        "Delete": "Permissions.UserClaims.Delete",
        "DDL": "Permissions.UserClaims.DDL"
    },
    "Products": {
        "View": "Permissions.Products.View",
        "Search": "Permissions.Products.Search",
        "Export": "Permissions.Products.Export",
        "Create": "Permissions.Products.Create",
        "Update": "Permissions.Products.Update",
        "Delete": "Permissions.Products.Delete"
    },
    "ProductBarcode": {
        "Generate": "permissions.productbarcode.generate"
    },
    "QuantityAvailable": {
        "View": "Permissions.QuantityAvailable.View",
        "Search": "Permissions.QuantityAvailable.Search",
        "Export": "Permissions.QuantityAvailable.Export"
    },
    "ProductGroup": {
        "View": "Permissions.ProductGroup.View",
        "Search": "Permissions.ProductGroup.Search",
        "Create": "Permissions.ProductGroup.Create",
        "Update": "Permissions.ProductGroup.Update",
        "Delete": "Permissions.ProductGroup.Delete"
    },
    "Categories": {
        "View": "Permissions.Categories.View",
        "Search": "Permissions.Categories.Search",
        "Create": "Permissions.Categories.Create",
        "Update": "Permissions.Categories.Update",
        "Delete": "Permissions.Categories.Delete"
    },
    "TaxCategory": {
        "View": "Permissions.TaxCategory.View",
        "Search": "Permissions.TaxCategory.Search",
        "Export": "Permissions.TaxCategory.Export",
        "Create": "Permissions.TaxCategory.Create",
        "Update": "Permissions.TaxCategory.Update",
        "Delete": "Permissions.TaxCategory.Delete"
    },
    "PriceLevel": {
        "View": "Permissions.PriceLevel.View",
        "Search": "Permissions.PriceLevel.Search",
        "Create": "Permissions.PriceLevel.Create",
        "Update": "Permissions.PriceLevel.Update",
        "Delete": "Permissions.PriceLevel.Delete"
    },
    "GLAccount": {
        "View": "Permissions.GLAccount.View",
        "Search": "Permissions.GLAccount.Search",
        "Export": "Permissions.GLAccount.Export",
        "Create": "Permissions.GLAccount.Create",
        "Update": "Permissions.GLAccount.Update",
        "Delete": "Permissions.GLAccount.Delete"
    },
    "FixedAsset": {
        "View": "Permissions.FixedAsset.View",
        "Search": "Permissions.FixedAsset.Search",
        "UpSert": "Permissions.FixedAsset.UpSert",
        "Delete": "Permissions.FixedAsset.Delete"
    },
    "GlAccountCategory": {
        "View": "Permissions.GlAccountCategory.View",
        "Search": "Permissions.GlAccountCategory.Search",
        "Create": "Permissions.GlAccountCategory.Create",
        "Update": "Permissions.GlAccountCategory.Update",
        "Delete": "Permissions.GlAccountCategory.Delete"
    },
    "GlAccountType": {
        "View": "Permissions.GlAccountType.View",
        "Search": "Permissions.GlAccountType.Search",
        "Create": "Permissions.GlAccountType.Create",
        "Update": "Permissions.GlAccountType.Update",
        "Delete": "Permissions.GlAccountType.Delete"
    },
    "FinancialStatementItem": {
        "View": "Permissions.FinancialStatementItem.View",
        "Search": "Permissions.FinancialStatementItem.Search",
        "Create": "Permissions.FinancialStatementItem.Create",
        "Update": "Permissions.FinancialStatementItem.Update",
        "Delete": "Permissions.FinancialStatementItem.Delete"
    },
    "DocumentType": {
        "View": "Permissions.DocumentType.View",
        "Search": "Permissions.DocumentType.Search",
        "Create": "Permissions.DocumentType.Create",
        "Update": "Permissions.DocumentType.Update",
        "Delete": "Permissions.DocumentType.Delete"
    },
    "Document": {
        "Sales": {
            "View": "Permissions.Sales.View",
            "Search": "Permissions.Sales.Search",
            "Create": "Permissions.Sales.Create",
            "Update": "Permissions.Sales.Update",
            "Delete": "Permissions.Sales.Delete",
            "Export": "Permissions.Sales.Export",
            "CreateReceiptVchInv": "Permissions.Sales.CreateReceiptVchInv",

        },
        "SalesReturn": {
            "View": "Permissions.SalesReturn.View",
            "Search": "Permissions.SalesReturn.Search",
            "Create": "Permissions.SalesReturn.Create",
            "Update": "Permissions.SalesReturn.Update",
            "Delete": "Permissions.SalesReturn.Delete",
            "Export": "Permissions.SalesReturn.Export"
        },
        "Purches": {
            "View": "Permissions.Purches.View",
            "Search": "Permissions.Purches.Search",
            "Create": "Permissions.Purches.Create",
            "Update": "Permissions.Purches.Update",
            "Delete": "Permissions.Purches.Delete",
            "Export": "Permissions.Purches.Export",
            "Generate": "permissions.Purches.Generate",
            "CreatePaymentVchInv": "Permissions.Purches.CreatePaymentVchInv"  
        },
        "PurchesReturn": {
            "View": "permissions.purchesreturn.view",
            "Search": "permissions.purchesreturn.search",
            "Create": "permissions.purchesreturn.create",
            "Update": "permissions.purchesreturn.update",
            "Delete": "permissions.purchesreturn.delete",
            "Export": "permissions.purchesreturn.export",
            "Generate": "permissions.purchesreturn.generate"
        },
        "OpeningStock": {
            "View": "Permissions.OpeningStock.View",
            "Search": "Permissions.OpeningStock.Search",
            "Create": "Permissions.OpeningStock.Create",
            "Update": "Permissions.OpeningStock.Update",
            "Delete": "Permissions.OpeningStock.Delete"
        },
        "ZATCA": {
            "View": "Permissions.DocumentZatca.View",
            "Generate": "Permissions.DocumentZatca.Generate",
        }
    },
    "OfferPrice": {
        "View": "Permissions.OfferPrice.View",
        "Search": "Permissions.OfferPrice.Search",
        "Export": "Permissions.OfferPrice.Export",
        "Create": "Permissions.OfferPrice.Create",
        "Update": "Permissions.OfferPrice.Update",
        "Delete": "Permissions.OfferPrice.Delete",
        "Generate": "Permissions.OfferPrice.Generate"
    },
     "Purches": {
            "View": "Permissions.Purches.View",
            "Search": "Permissions.Purches.Search",
            "Create": "Permissions.Purches.Create",
            "Update": "Permissions.Purches.Update",
            "Delete": "Permissions.Purches.Delete",
            "Export": "Permissions.Purches.Export",
            "Generate": "permissions.Purches.Generate",
            "CreatePaymentVchInv": "Permissions.Purches.CreatePaymentVchInv"  
        },
    "Currencies": {
        "View": "Permissions.Currencies.View",
        "Search": "Permissions.Currencies.Search",
        "Create": "Permissions.Currencies.Create",
        "Update": "Permissions.Currencies.Update",
        "Delete": "Permissions.Currencies.Delete"
    },
    "Shift": {
        "View": "Permissions.Shift.View",
        "Search": "Permissions.Shift.Search",
        "Create": "Permissions.Shift.Create",
        "Update": "Permissions.Shift.Update",
        "Delete": "Permissions.Shift.Delete"
    },
    "ShiftCategory": {
        "View": "Permissions.ShiftCategory.View",
        "Search": "Permissions.ShiftCategory.Search",
        "Create": "Permissions.ShiftCategory.Create",
        "Update": "Permissions.ShiftCategory.Update",
        "Delete": "Permissions.ShiftCategory.Delete"
    },
    "Brands": {
        "View": "Permissions.Brands.View",
        "Search": "Permissions.Brands.Search",
        "Create": "Permissions.Brands.Create",
        "Update": "Permissions.Brands.Update",
        "Delete": "Permissions.Brands.Delete",
        "Clean": "Permissions.Brands.Clean"
    },
    "Module": {
        "View": "Permissions.Module.View",
        "Search": "Permissions.Module.Search",
        "Create": "Permissions.Module.Create",
        "Update": "Permissions.Module.Update",
        "Delete": "Permissions.Module.Delete"
    },
    "Page": {
        "View": "Permissions.Page.View",
        "Search": "Permissions.Page.Search",
        "Create": "Permissions.Page.Create",
        "Update": "Permissions.Page.Update",
        "Delete": "Permissions.Page.Delete"
    },
    "PageType": {
        "View": "Permissions.PageType.View",
        "Search": "Permissions.PageType.Search",
        "Create": "Permissions.PageType.Create",
        "Update": "Permissions.PageType.Update",
        "Delete": "Permissions.PageType.Delete"
    },
    "PricingPlan": {
        "View": "Permissions.PricingPlan.View",
        "Search": "Permissions.PricingPlan.Search",
        "Create": "Permissions.PricingPlan.Create",
        "Update": "Permissions.PricingPlan.Update",
        "Delete": "Permissions.PricingPlan.Delete"
    },
    "SubscriptionPackage": {
        "View": "Permissions.SubscriptionPackage.View",
        "Search": "Permissions.SubscriptionPackage.Search",
        "Create": "Permissions.SubscriptionPackage.Create",
        "Update": "Permissions.SubscriptionPackage.Update",
        "Delete": "Permissions.SubscriptionPackage.Delete"
    },
    "Feature": {
        "View": "Permissions.Feature.View",
        "Search": "Permissions.Feature.Search",
        "Create": "Permissions.Feature.Create",
        "Update": "Permissions.Feature.Update",
        "Delete": "Permissions.Feature.Delete"
    },
    "Tenants": {
        "View": "Permissions.Tenants.View",
        "Search": "Permissions.Tenants.Search",
        "Create": "Permissions.Tenants.Create",
        "Delete": "Permissions.Tenants.Delete",
        "Update": "Permissions.Tenants.Update",
        "Activate": "Permissions.Tenants.Activate",
        "Deactivate": "Permissions.Tenants.Deactivate",
        "UpgradeSubscription": "Permissions.Tenants.UpgradeSubscription"
    },
    "Payment": {
        "View": "Permissions.Payment.View",
        "Search": "Permissions.Payment.Search",
        "Create": "Permissions.Payment.Create",
        "Update": "Permissions.Payment.Update",
        "Delete": "Permissions.Payment.Delete",
        "Activate": "Permissions.Payment.Activate",
        "Export": "Permissions.Payment.Export"
    },
    "EmailMessage": {
        "View": "Permissions.EmailMessage.View",
        "Search": "Permissions.EmailMessage.Search",
        "Create": "Permissions.EmailMessage.Create"
    },
    "WhatsappMessage": {
        "View": "Permissions.WhatsappMessage.View",
        "Search": "Permissions.WhatsappMessage.Search",
        "Create": "Permissions.WhatsappMessage.Create"
    },
    "SMSMessage": {
        "View": "Permissions.SMSMessage.View",
        "Search": "Permissions.SMSMessage.Search",
        "Create": "Permissions.SMSMessage.Create"
    },
    "MessageLog": {
        "View": "Permissions.MessageLog.View",
        "Search": "Permissions.MessageLog.Search"
    },
    "ScheduleTemplate": {
        "View": "Permissions.ScheduleTemplate.View",
        "Search": "Permissions.ScheduleTemplate.Search",
        "Create": "Permissions.ScheduleTemplate.Create",
        "Update": "Permissions.ScheduleTemplate.Update",
        "Delete": "Permissions.ScheduleTemplate.Delete"
    },
    "Attachments": {
        "Upload": "Permissions.Attachments.Upload",
        "GetById": "Permissions.Attachments.GetById",
        "View": "Permissions.Attachments.View",
        "Delete": "Permissions.Attachments.Delete",
        "Download": "Permissions.Attachments.Download"
    },
    "SubscriptionManagement": {
        "View": "Permissions.SubscriptionManagement.View",
        "Renew": "Permissions.SubscriptionManagement.Renew",
        "Upgrade": "Permissions.SubscriptionManagement.Upgrade"
    },
    "InvoicesReport": {
        "View": "permissions.invoicesreport.view",
        "Search": "permissions.invoicesreport.search",
        "Export": "permissions.invoicesreport.export"
    },
    "AccountStatement": {
        "View": "permissions.accountstatement.view",
        "Search": "permissions.accountstatement.search",
        "Export": "permissions.accountstatement.export"
    },
    "CustomerAccountStatement": {
        "View": "permissions.customeraccountstatement.view",
        "Search": "permissions.customeraccountstatement.search",
        "Export": "permissions.customeraccountstatement.export"
    },
    "SupplierAccountStatement": {
        "View": "permissions.supplieraccountstatement.view",
        "Search": "permissions.supplieraccountstatement.search",
        "Export": "permissions.supplieraccountstatement.export"
    },
    "TaxReturn": {
        "View": "permissions.taxreturn.view",
        "Search": "permissions.taxreturn.search",
        "Export": "permissions.taxreturn.export"
    },
    "GeneralLedger": {
        "View": "Permissions.GeneralLedger.View",
        "Search": "Permissions.GeneralLedger.Search",
        "Export": "Permissions.GeneralLedger.Export"
    },
    "TrialBalance": {
        "View": "permissions.trialbalance.view",
        "Export": "permissions.trialbalance.export"
    },
    "StockMovement": {
        "View": "permissions.inventorymovement.view",
        "Search": "permissions.inventorymovement.search",
        "Export": "permissions.inventorymovement.export"
    },
    "ActualInventory": {
        "View": "permissions.actualinventory.view",
        "Search": "permissions.actualinventory.search",
        "Export": "permissions.actualinventory.export"
    },
    "CustomerInvoicesReport": {
        "View": "permissions.customerinvoicesreport.view",
        "Search": "permissions.customerinvoicesreport.search",
        "Export": "permissions.customerinvoicesreport.export"
    },
    "SupplierInvoicesReport": {
        "View": "permissions.supplierinvoicesreport.view",
        "Search": "permissions.supplierinvoicesreport.search",
        "Export": "permissions.supplierinvoicesreport.export"
    },

    "PurchaseReturn": {
        "View": "permissions.purchasereturn.view",
        "Search": "permissions.purchasereturn.search",
        "Export": "permissions.purchasereturn.export",
        "Create": "permissions.purchasereturn.create",
        "Update": "permissions.purchasereturn.update",
        "Delete": "permissions.purchasereturn.delete",
        "Generate": "permissions.purchasereturn.generate",
        "CreatePaymentVchInv": "permissions.purchasereturn.createpaymentvchin" 
    },
    "PurchaseOrders": {
        "View": "permissions.purchaseorders.view",
        "Search": "permissions.purchaseorders.search",
        "Create": "permissions.purchaseorders.create",
        "Update": "permissions.purchaseorders.update",
        "Delete": "permissions.purchaseorders.delete",
        "Approve": "Permissions.PurchaseOrders.Approve",
        "Send": "Permissions.PurchaseOrders.Send",
        "Cancel":"Permissions.PurchaseOrders.Cancel",
        "Close": "Permissions.PurchaseOrders.Close",
        "Reject": "Permissions.PurchaseOrders.Reject"

    },
    "SalesOrders": {
        "View": "Permissions.SalesOrder.View",
        "Search": "Permissions.SalesOrder.Search",
        "Create": "Permissions.SalesOrder.Create",
        "Update": "Permissions.SalesOrder.Update",
        "Delete": "Permissions.SalesOrder.Delete",
        "Approve": "Permissions.SalesOrder.Approve",
        "Reject": "Permissions.SalesOrder.Reject"
    },
    "DeliveryNotes": {
        "View": "Permissions.DeliveryNote.View",
        "Search": "Permissions.DeliveryNote.Search",
        "Create": "Permissions.DeliveryNote.Create",
        "Update": "Permissions.DeliveryNote.Update",
        "Delete": "Permissions.DeliveryNote.Delete",
        "Approve": "Permissions.DeliveryNote.Approve"
    },
    "GoodsReceipts": {
        "View": "Permissions.GoodsReceipts.View",
        "Search": "Permissions.GoodsReceipts.Search",
        "Create": "Permissions.GoodsReceipts.Create"
    },
    "PurchaseRequisitions": {
        "View": "Permissions.PurchaseRequisitions.View",
        "Search": "Permissions.PurchaseRequisitions.Search",
        "Create": "Permissions.PurchaseRequisitions.Create",
        "Update": "Permissions.PurchaseRequisitions.Update",
        "Delete": "Permissions.PurchaseRequisitions.Delete",
        "Submit": "Permissions.PurchaseRequisitions.Submit",
        "Approve": "Permissions.PurchaseRequisitions.Approve",
        "Reject": "Permissions.PurchaseRequisitions.Reject"
    },
    "Sales": {
        "View": "Permissions.Sales.View",
        "Search": "Permissions.Sales.Search",
        "Export": "Permissions.Sales.Export",
        "Create": "Permissions.Sales.Create",
        "Update": "Permissions.Sales.Update",
        "Delete": "Permissions.Sales.Delete",
        "Generate": "Permissions.Sales.Generate",
        "CreateReceiptVchInv": "Permissions.Sales.CreateReceiptVchInv"
    },
    "SalesReturn": {
        "View": "Permissions.SalesReturn.View",
        "Search": "Permissions.SalesReturn.Search",
        "Export": "Permissions.SalesReturn.Export",
        "Create": "Permissions.SalesReturn.Create",
        "Update": "Permissions.SalesReturn.Update",
        "Delete": "Permissions.SalesReturn.Delete",
        "Generate": "Permissions.SalesReturn.Generate"
        
    },
    "CustomerRelations": {
        "View": "Permissions.CustomerRelations.View",
        "Search": "Permissions.CustomerRelations.Search",
        "Create": "Permissions.CustomerRelations.Create",
        "Update": "Permissions.CustomerRelations.Update",
        "Delete": "Permissions.CustomerRelations.Delete"
    },
    "POSTerminals": {
        "View": "Permissions.POSTerminals.View",
        "Search": "Permissions.POSTerminals.Search",
        "Create": "Permissions.POSTerminals.Create",
        "Update": "Permissions.POSTerminals.Update",
        "Delete": "Permissions.POSTerminals.Delete"
    },
    "POSSales": {
        "View": "Permissions.POSSales.View",
        "Search": "Permissions.POSSales.Search",
        "Create": "Permissions.POSSales.Create",
        "Update": "Permissions.POSSales.Update",
        "Delete": "Permissions.POSSales.Delete",
        "Export": "Permissions.POSSales.Export"
    },
    "POSReturn": {
        "View": "Permissions.POSReturn.View",
        "Search": "Permissions.POSReturn.Search",
        "Create": "Permissions.POSReturn.Create",
        "Update": "Permissions.POSReturn.Update",
        "Delete": "Permissions.POSReturn.Delete",
        "Export": "Permissions.POSReturn.Export"
    },
    "POSReports": {
        "View": "Permissions.POSReports.View",
        "Search": "Permissions.POSReports.Search",
        "Export": "Permissions.POSReports.Export"
    },
    "DocumentZatca": {
        "View": "Permissions.DocumentZatca.View",
        "Search": "Permissions.DocumentZatca.Search",
        "Export": "Permissions.DocumentZatca.Export",
        "Generate": "Permissions.DocumentZatca.Generate"
    },
    "MessageTemplate": {
        "View": "Permissions.MessageTemplate.View",
        "Search": "Permissions.MessageTemplate.Search",
        "Create": "Permissions.MessageTemplate.Create"
    },
    "Closing": {
        "Close": "Permissions.Closing.Close",
        "Cancel": "Permissions.Closing.Cancel",
        "Validate": "Permissions.Closing.Validate",
        "Search": "Permissions.Closing.Search",
        "View": "Permissions.Closing.View"
    },
    "BranchesTransfer": {
        "View": "Permissions.BranchTransfer.View",
        "Search": "Permissions.BranchTransfer.Search",
        "Create": "Permissions.BranchTransfer.Create",
        "Update": "Permissions.BranchTransfer.Update",
        "Delete": "Permissions.BranchTransfer.Delete",
        "Export": "Permissions.BranchTransfer.Export"
    },
    "WarehousesTransfer": {
        "View": "Permissions.WarehouseTransfer.View",
        "Search": "Permissions.WarehouseTransfer.Search",
        "Create": "Permissions.WarehouseTransfer.Create",
        "Update": "Permissions.WarehouseTransfer.Update",
        "Delete": "Permissions.WarehouseTransfer.Delete",
        "Export": "Permissions.WarehouseTransfer.Export"
    },
    "WarehouseIssueOrder": {
        "View": "Permissions.InventoryDisbursement.View",
        "Search": "Permissions.InventoryDisbursement.Search",
        "Create": "Permissions.InventoryDisbursement.Create",
        "Update": "Permissions.InventoryDisbursement.Update",
        "Delete": "Permissions.InventoryDisbursement.Delete",
        "Export": "Permissions.InventoryDisbursement.Export"
    },
    "WarehouseSupplyOrder": {
        "View": "Permissions.InventorySupply.View",
        "Search": "Permissions.InventorySupply.Search",
        "Create": "Permissions.InventorySupply.Create",
        "Update": "Permissions.InventorySupply.Update",
        "Delete": "Permissions.InventorySupply.Delete",
        "Export": "Permissions.InventorySupply.Export",
    }
}
